import { authClient, baseClient } from "../api/index";

export const safeGet = async (url, useAuth = true) => {
  try {
    const client = useAuth ? authClient() : baseClient();
    const res = await client.get(url);
    return { status: res.status, data: res.data };
  } catch (error) {
    if (error.response) {
      return {
        status: error.response.status,
        data: error.response.data,
      };
    } else {
      console.error("Error inesperado o de red:", error);
      return { status: 500, data: null };
    }
  }
};
